<div class="row justify-content-between">
  <div class="col-xs-6 ms-0 col main-header">
    <h3>Remittance Financing</h3>
  </div>
  <div class="me-4 ms-3 col-auto">
    <button class="btn btn-info whitetext" [disabled]="+this.tS.fquotetotal['request']==0 || this.fQ.p_payment_date==null" (click)="requestquotation()">Request Quotation</button>
  </div>
</div>
<br>
<div class="formform-group row align-items-center justify-content-left">
  <!-- Material input -->
  <label for="p_amount" class="col col-form-label">Amount Required</label>
  <div class="col-4 align-items-center">
    <div class="md-form mt-2 mb-0">
      <input mdbInput type="text" style="text-align:center;" step="1" min="0" [max]="this.tS.fquotetotal['max']" class="form-control" id="p_amount" value="10" [ngModel]="this.tS.p_amount | currency:this.tS.fquotetotal['currency']:'symbol-narrow'" [ngModelOptions]="{updateOn:'blur'}" (ngModelChange)="onInput($event)">
    </div>
  </div>
  <div class="col-4 align-items-center">
    <mat-slider
      id="p_amount"
      class="example-margin fullwidth"
      style="width:100%;min-width:75px;"
      [max]="this.tS.fquotetotal['max']"
      [min]="0"
      [step]="1"
      #ngSlider ngDefaultControl>
      <input matSliderThumb [ngModel]="this.tS.p_amount" (input)="onInputChange({source: ngSliderThumbskr, parent: ngSlider, value: ngSliderThumbskr.value})" #ngSliderThumbskr="matSliderThumb" />
    </mat-slider>
  </div>
</div>
<div class="formform-group row align-items-center justify-content-left">
  <!-- Material input -->
  <label for="p_amount" class="col col-form-label">Date of Payment</label>
  <div class="col-8 col-md-4 align-items-right">
    <mat-form-field class="fullwidth">
      <mat-label>Payment Date</mat-label>
      <input matInput [matDatepicker]="paymentdate" [(ngModel)]="this.fQ.p_payment_date" (ngModelChange)="this.fQ.fixDate('p_payment_date')" [min]="minDate" [max]="maxDate" [matDatepickerFilter]="holidayFilter">
      <mat-datepicker-toggle matIconSuffix [for]="paymentdate"></mat-datepicker-toggle>
      <mat-datepicker #paymentdate [dateClass]="dateClass"></mat-datepicker>
    </mat-form-field>
  </div>
</div>
<br>
<table class="table col-sm">
  <tbody>
    <tr class="tableseperator"><td></td><td></td><td></td><td></td></tr>
    <tr class="tableheader">
      <td>Delivery</td>
      <td>Total Value (inc. VAT)</td>
      <td>Maximum Available</td>
      <td>Requested Amount</td>
    </tr>
    <tr class="tableseperator"><td></td><td></td><td></td><td></td></tr>
    <tr class="tableheader">
      <td>Total</td>
      <td>{{ this.tS.fquotetotal['total'] | currency:this.tS.fquotetotal['currency']:'symbol-narrow' }}</td>
      <td>{{ this.tS.fquotetotal['max'] | currency:this.tS.fquotetotal['currency']:'symbol-narrow' }}</td>
      <td>{{ this.tS.fquotetotal['request'] | currency:this.tS.fquotetotal['currency']:'symbol-narrow' }}</td>
    </tr>
    @for (rquote of this.tS.fquote; track rquote; let i = $index) {
      @if (i==0) {
        <tr class="tableseperator"><td></td><td></td><td></td><td></td></tr>
      }
      @if (i>0) {
        <tr class="tableseperatorlight"><td></td><td></td><td></td><td></td></tr>
      }
      <tr>
        <td>Payments due {{ rquote['repaydate'] }} [{{ rquote['instalment'] }}]</td>
        <td>{{ rquote['total'] | currency:rquote['currency']:'symbol-narrow' }}</td>
        <td>{{ rquote['max'] | currency:rquote['currency']:'symbol-narrow' }}</td>
        <td>{{ rquote['request'] | currency:rquote['currency']:'symbol-narrow' }}</td>
      </tr>
    }
    <tr class="tableseperator"><td></td><td></td><td></td><td></td></tr>
  </tbody>
</table>
<div class="col" id="popup">
  <div class="form-container text-center justify-content-center" autocomplete="off">
    <h4><strong>Review Advance Payment Quotation</strong></h4>
    <br>
    <div class="row justify-content-between">
      <h4 class="col-auto tal">Advance Payment Amount (inc. VAT):</h4>
      @if (this.fQ.fFS.loading) {
        <h4 class="col-auto"><i class="pi pi-refresh pi-spin"></i></h4>
      }
      @if (!this.fQ.fFS.loading) {
        <h4 class="col-auto">{{ this.fQ.fFS.totalrequest | currency:this.tS.fquotetotal['currency']:'symbol-narrow' }}</h4>
      }
    </div>
    <div class="row justify-content-between">
      <h4 class="col-auto tal">Early Payment Fee (ex. VAT):</h4>
      @if (this.fQ.fFS.loading) {
        <h4 class="col-auto"><i class="pi pi-refresh pi-spin"></i></h4>
      }
      @if (!this.fQ.fFS.loading) {
        <h4 class="col-auto">{{ this.fQ.fFS.feesexvat | currency:this.tS.fquotetotal['currency']:'symbol-narrow' }}</h4>
      }
    </div>
    <div class="row justify-content-between">
      <h4 class="col-auto tal">Early Payment Fee VAT:</h4>
      @if (this.fQ.fFS.loading) {
        <h4 class="col-auto"><i class="pi pi-refresh pi-spin"></i></h4>
      }
      @if (!this.fQ.fFS.loading) {
        <h4 class="col-auto">{{ this.fQ.fFS.feesvat | currency:this.tS.fquotetotal['currency']:'symbol-narrow' }}</h4>
      }
    </div>
    <div class="row justify-content-between">
      <h4 class="col-auto tal">Early Payment Fee (inc. VAT):</h4>
      @if (this.fQ.fFS.loading) {
        <h4 class="col-auto"><i class="pi pi-refresh pi-spin"></i></h4>
      }
      @if (!this.fQ.fFS.loading) {
        <h4 class="col-auto">{{ this.fQ.fFS.feesincvat | currency:this.tS.fquotetotal['currency']:'symbol-narrow' }}</h4>
      }
    </div>
    <div class="row justify-content-between">
      <h4 class="col-auto tal">Amount to be Deducted from Future Payments (inc. VAT):</h4>
      @if (this.fQ.fFS.loading) {
        <h4 class="col-auto"><i class="pi pi-refresh pi-spin"></i></h4>
      }
      @if (!this.fQ.fFS.loading) {
        <h4 class="col-auto">{{ this.fQ.fFS.totalcost | currency:this.tS.fquotetotal['currency']:'symbol-narrow' }}</h4>
      }
    </div>
    <div class="row justify-content-between">
      <h4 class="col-auto tal">Payment Date:</h4>
      @if (this.fQ.fFS.loading) {
        <h4 class="col-auto"><i class="pi pi-refresh pi-spin"></i></h4>
      }
      @if (!this.fQ.fFS.loading) {
        <h4 class="col-auto">{{ this.fQ.fFS.payment_date }}</h4>
      }
    </div>
    <br>
    <h4 class="instruction">After accepting this quotation you will recieve an email at<br><i>{{ this.fQ.fFS.email }}</i><br>with a docusign link to enable your funds to be released.</h4>
    <br>
    <p><strong>Privacy Policy:</strong><br>The Parties acknowledge and agree that any exchange of personal information between them shall be conducted in accordance with the provisions of the Protection of Personal Information Act, 4 of 2013 ("POPIA"). Each Party consents to the processing and sharing of personal information strictly for purposes related to this Agreement and undertakes to implement appropriate, reasonable technical and organisational measures to safeguard such information. Neither Party shall disclose or otherwise process personal information in its possession unless required for the fulfilment of this Agreement, or as required by law or with the express written consent of the data subject or the other Party.</p>
    <mat-checkbox
      [(ngModel)]="this.fQ.policyChecked">
      I Agree to the Privacy Policy
    </mat-checkbox>
    <br>
    <button class="btn btn-primary quoteButton" [disabled]="!this.fQ.policyChecked || this.fQ.fFS.accepting" (click)="acceptQuote()">
      @if (!this.fQ.fFS.accepting) {
          Accept Quotation
      } @else {
        <i class="pi pi-refresh pi-spin"></i>
      }
    </button>
    <br>
    <button class="btn btn-danger quoteButton" [disabled]="this.fQ.fFS.accepting" (click)="cancelQuote()">
      @if (!this.fQ.fFS.accepting) {
          Cancel
      } @else {
        <i class="pi pi-refresh pi-spin"></i>
      }
    </button>
  </div>
</div>
<br>
<div class="text-center">Requesting payments from earlier dates will cost less.</div>
<br>
<div class="text-center">
  Requesting a quote doesn't share any of your personal information with 3rd parties.
  <br>
  Some personal details will be shared with Forward Finance once
  <br>
  you accept the quote and wish to proceed with signing of contracts.
</div>